var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-2",attrs:{"loading":_vm.loading,"items-per-page":15,"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.moment(item.date).format("DD/MM/YYYY"))+" ")]}},{key:"item.lastUpdate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.moment(item.lastUpdate).format("DD/MM/YYYY HH:mm:ss"))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }